import React from "react";
import { ReportHeader } from "../../../../../components/ReportHeader/ReportHeader";
import { Button } from "../../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { svg } from "../../../../../../../assets/svg";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";

const Header = ({ download }) => {
  const { tCommon } = useAppTranslation.Common();
  const { tBi } = useAppTranslation.BusinessInsights();
  return (
    <ReportHeader
      withBackBtn
      media="small"
      label={tBi("verticalsUsageReport.label")}
    >
      <Button
        variant="outlined"
        onClick={download.initiate}
        isDisabled={download.isLoading}
        leftAdornment={
          download.isLoading ? (
            <CircularProgress size="small" />
          ) : (
            <img src={svg.downloadPrimary} alt="dl" width="20px" />
          )
        }
        size="small"
      >
        {tCommon("label.downloadExcel")}
      </Button>
    </ReportHeader>
  );
};

export default Header;
